import React from 'react';
import { Menu, MenuTrigger, MenuPopover, MenuList, MenuItem } from '@fluentui/react-components';
import styles from './css/index.module.css';
import { RACI_VALUES } from './raciConstants';

const valueClass = value => {
    switch (value) {
        case 'R':
            return styles.raciBadgeR;
        case 'A':
            return styles.raciBadgeA;
        case 'C':
            return styles.raciBadgeC;
        case 'I':
            return styles.raciBadgeI;
        default:
            return '';
    }
};

const RaciAssignmentCell = ({ value, readOnly, focused, onFocus, onBlur, onChange }) => {
    const handleKeyDown = e => {
        if (readOnly) return;
        const key = e.key.toUpperCase();
        if (RACI_VALUES.includes(key)) {
            e.preventDefault();
            onChange(key);
            return;
        }
        if (e.key === 'Backspace' || e.key === 'Delete') {
            e.preventDefault();
            onChange('');
        }
    };

    const badge = value ? (
        <span className={`${styles.raciBadge} ${valueClass(value)}`}>{value}</span>
    ) : (
        <span className={`${styles.raciBadge} ${styles.raciBadgeBlankLegend}`} aria-hidden="true">—</span>
    );

    if (readOnly) {
        return (
            <td className={styles.matrixCell} tabIndex={-1}>
                <div className={styles.matrixCellInner}>{badge}</div>
            </td>
        );
    }

    return (
        <td className={`${styles.matrixCell} ${focused ? styles.matrixCellFocused : ''}`}>
            <Menu positioning="below">
                <MenuTrigger disableButtonEnhancement>
                    <button
                        type="button"
                        className={styles.matrixCellButton}
                        aria-label="RACI assignment"
                        onFocus={onFocus}
                        onBlur={onBlur}
                        onKeyDown={handleKeyDown}>
                        {badge}
                    </button>
                </MenuTrigger>
                <MenuPopover>
                    <MenuList>
                        {RACI_VALUES.map(option => (
                            <MenuItem key={option} onClick={() => onChange(option)}>
                                <span className={`${styles.raciBadge} ${valueClass(option)} ${styles.raciBadgeMenu}`}>{option}</span>
                                <span className={styles.menuRaciLabel}>
                                    {option === 'R' && 'Responsible'}
                                    {option === 'A' && 'Accountable'}
                                    {option === 'C' && 'Consulted'}
                                    {option === 'I' && 'Informed'}
                                </span>
                            </MenuItem>
                        ))}
                        <MenuItem onClick={() => onChange('')}>Clear assignment</MenuItem>
                    </MenuList>
                </MenuPopover>
            </Menu>
        </td>
    );
};

export default RaciAssignmentCell;
